import TwoColumnRepository from "../TwoColumnRepository"

export default class OurStoryTwoColumnRepository extends TwoColumnRepository {
    static schemaId = "company_twoColumn"

    constructor() {
        super(OurStoryTwoColumnRepository.schemaId)
    }
}
